import React from "react";
import logo from "../../../assets/tenants/il_parrocchiale/logo_il_parrocchiale.png";
import volantino2026 from "../../../assets/tenants/il_parrocchiale/volantino2026.jpg";
import { currentTenant } from "../../../tenants";

export const IlParrocchialeAboutUsPage: React.FC = () => {
  return (
    <div className="bg-gray-50 py-10 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto space-y-12">
        <section className="md:text-center sm:text-left">
          <img
            src={logo}
            alt="Logo Il Parrocchiale"
            className="w-full max-w-xs mx-auto mb-6"
          />

          <h1 className="text-3xl sm:text-4xl font-extrabold mb-4">
            Chi siamo
          </h1>
          <p className="text-gray-700">
            <span className="font-semibold">Il Parrocchiale</span> é un torneo sportivo organizzato 
            con continuità dal 2010 dalla <strong>Parrocchia di San Luigi Gonzaga di Reggio Emilia</strong>, 
            nato all'interno della sagra della Parrocchia per favorire aggregazione, amicizia e un sano spirito sportivo.
          </p>
        </section>

        <section className="md:text-center sm:text-left">
          <h2 className="text-2xl font-bold mb-3 text-gray-800">
            Come nasce
          </h2>
          <p className="text-gray-600">
            Il torneo nasce inizialmente come torneo di calcetto, aperto a parrocchiani e non. 
            Dall'anno 2017 assume il nome "<span className="font-semibold">Il Parrocchiale</span>", 
            diventando un torneo di calcetto fra le varie parrocchie di 
            <strong>Reggio Emilia</strong>, dando nuova forma ad uno storico torneo 
            di <strong>Reggio Emilia</strong>. Dall'anno scorso, 2025, ha cambiato formula per diventare un 
            evento più vario, capace di coinvolgere più persone e più stili di gioco.
          </p>
        </section>
  
        <section className="md:text-center sm:text-left">
          <h2 className="text-2xl font-bold mb-4 text-gray-800">
            Il formato attuale
          </h2>
          <p className="text-gray-600 mb-4">
            Oggi Il Parrocchiale é un torneo multisport costruito attorno a tre
            discipline:
          </p>
          <ul className="list-disc list-inside space-y-2 text-gray-600">
            <li>
              <strong>Pallavolo</strong>
            </li>
            <li>
              <strong>Dodgeball</strong>
            </li>
            <li>
              <strong>Biliardo coi piedi</strong>
            </li>
          </ul>
  
        </section>

        <section className="md:text-center sm:text-left">
          <h2 className="text-2xl font-bold mb-4 text-gray-800">
            Lo spirito del torneo
          </h2>
          <p className="text-gray-600 mb-4">
            Le squadre sono <strong>miste</strong>, uomini e donne, scelta che riflette bene 
            l'identità dell'iniziativa: un torneo competitivo, ma prima ancora comunitario, 
            dove contano partecipazione, rispetto e voglia di stare insieme.
          </p>
        </section>

      
        <section className="md:text-center sm:text-left">
          <h2 className="text-2xl font-bold mb-3 text-gray-800">
            Edizione attuale
          </h2>
          <p className="text-gray-600">
            Quella di quest'anno, 2026, sarà la <strong>seconda edizione</strong> del torneo 
            nel nuovo formato multisport. L'obiettivo resta lo stesso: offrire alla comunità 
            e a chiunque voglia partecipare un appuntamento bello da vivere, organizzato 
            con spirito parrocchiale ma aperto al divertimento e alla sana competizione.
          </p>
        </section>

        <div className="mt-6">
          <img
            src={volantino2026}
            alt="Volantino 2026"
            className="rounded shadow-md mx-auto w-full max-w-lg"
          />
        </div>

        <section className="md:text-center sm:text-left">
          <h2 className="text-2xl font-bold mb-3 text-gray-800">
            Iscrizioni
          </h2>
          <p className="text-gray-600">
            Per iscriversi è sufficiente compilare il 
            <a href={currentTenant.registrationLink || ""} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="text-yellow-500 hover:underline mx-1">
              modulo seguendo questo link
            </a> 
            o cliccando sulla voce del menu "Iscrizioni".
            Puoi iscrivere la tua squadra come responsabile o, se non hai un team, iscriverti come singolo.
          </p>
        </section>

        <section className="md:text-center sm:text-left">
          <h2 className="text-2xl font-bold mb-3 text-gray-800">
            Formato
          </h2>
          <p className="text-gray-600 mb-4">
            Il torneo si svolge in 3 serate, suddivise in fasi eliminatorie e serata finale.
          </p>
          <ul className="list-disc list-inside space-y-1 text-gray-600 mb-4">
            <li>
              <strong>Martedì 16 Giugno</strong>
            </li>
            <li>
              <strong>Giovedì 18 Giugno</strong>
            </li>
            <li>
              <strong>Finali: Sabato 20 Giugno</strong> 
            </li>
          </ul>
          <p className="text-gray-600">
            Ogni torneo è indipendente, quindi la tua squadra può tranquillamente arrivare 
            in finale in un determinato sport a prescindere dai risultati negli altri due.
          </p>
          <p className="text-gray-600">
            Il costo di iscrizione è di 15 euro a testa, comprensivo della pizza prevista per la serata finale.
          </p>
          <p className="text-gray-600">
            Il torneo è aperto dai 15 anni in su.
          </p>
          <p className="text-gray-600">
            In ciascuna serata del torneo è previsto il servizio bar, con cibo e bevande.
          </p>
        </section>

      </div>
    </div>
  );
};

